import type { AVPromptSource } from "@/common/buses";

export const AGE_VERIFICATION_TOKEN_PARAM = "avt";
export const AGE_VERIFICATION_SOURCE_PARAM = "source";
const AGE_VERIFICATION_STATUS_PARAM = "verification";

export const AGE_VERIFICATION_SUCCESS = "success";
export const AGE_VERIFICATION_FAILED = "failed";

type AgeVerificationStatus =
  | typeof AGE_VERIFICATION_SUCCESS
  | typeof AGE_VERIFICATION_FAILED;

const getSearchParam = (search: string, param: string): string | null => {
  if (!search) {
    return null;
  }

  return new URLSearchParams(search).get(param);
};

export const getAgeVerificationTokenFromSearch = (search: string): string | null =>
  getSearchParam(search, AGE_VERIFICATION_TOKEN_PARAM);

export const getAgeVerificationSourceFromSearch = (search: string): AVPromptSource | null => {
  const value = getSearchParam(search, AGE_VERIFICATION_SOURCE_PARAM);

  return value === "immediate" || value === "delayed" ? value : null;
};

export const getAgeVerificationStatusFromSearch = (
  search: string
): AgeVerificationStatus | null => {
  const value = getSearchParam(search, AGE_VERIFICATION_STATUS_PARAM);

  if (!value) {
    return null;
  }

  const normalized = value.toLowerCase();

  if (normalized === AGE_VERIFICATION_SUCCESS) {
    return AGE_VERIFICATION_SUCCESS;
  }

  if (normalized === AGE_VERIFICATION_FAILED) {
    return AGE_VERIFICATION_FAILED;
  }

  return null;
};
